import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaiairporttopunecab() {



  const cardData = {
    keyword: " Mumbai Airport to Pune Cabs ",


"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai Airport to Pune cab services, ensuring a safe, smooth, and hassle-free transfer for business travelers, tourists, and families arriving at Chhatrapati Shivaji Maharaj International Airport. Pune is a major educational and IT hub known for its pleasant climate, cultural heritage, and corporate presence, making it one of the most frequently traveled routes from Mumbai Airport. Our professional drivers provide timely airport pickups with flight tracking, meet-and-greet support, and well-maintained vehicles for a stress-free journey. ",

topPlaces: [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fort palace in Pune built in 1732 by the Peshwas of the Maratha Empire. It is known for its grand architecture, massive gates, and rich history. Today, it is a popular tourist attraction showcasing Pune’s royal Maratha heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a significant historical landmark in Pune, famous for its role in India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and other leaders were once imprisoned here. The palace also features beautiful architecture and serene gardens."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is one of the most famous and revered temples in Pune dedicated to Lord Ganesha. Known for its grand celebrations during Ganesh Chaturthi, it attracts thousands of devotees every year."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fort located near Pune, known for its trekking routes and panoramic views. It holds great significance in Maratha history, especially related to Tanaji Malusare and Chhatrapati Shivaji Maharaj."
  },
  {
    "title": "Parvati Hill",
    "description": "Parvati Hill is a popular viewpoint in Pune offering a panoramic view of the city. The hill also houses ancient temples and is a peaceful spot for trekking, photography, and sunrise views."
  },
  {
    "title": "Osho Ashram (Osho International Meditation Resort)",
    "description": "Osho Ashram in Koregaon Park is a world-famous meditation center known for its peaceful environment, spiritual teachings, and wellness programs attracting visitors from across the globe."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a scenic picnic spot near Pune, especially popular during monsoon. The surrounding greenery and water views make it a relaxing getaway for families and couples."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, located in the heart of Pune city. It is known for its unique architecture carved out of a single rock."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum showcases a vast collection of artifacts, sculptures, musical instruments, and everyday objects from India’s cultural history. It is one of Pune’s most interesting museums."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic landmark associated with Chhatrapati Shivaji Maharaj’s childhood. The reconstructed structure in Pune showcases important events from Maratha history."
  }
],






services: [
  {
    name: "Mumbai Airport to Pune Cabs",
    description: "Mumbai Airport to Pune cabs provide a seamless and comfortable transfer service for travelers arriving at the airport. This service ensures direct pickup from terminals and smooth travel via the expressway to Pune. Ideal for business travelers, families, and tourists, it guarantees timely and safe journeys. Professional drivers and clean vehicles enhance comfort. Multiple vehicle options are available. It ensures a hassle-free airport transfer experience."
  },
  {
    name: "Mumbai to Pune Cab Service",
    description: "Mumbai to Pune cab service offers reliable intercity travel with a focus on comfort and safety. The route via the Mumbai-Pune Expressway ensures fast and smooth travel. This service is ideal for daily commuters, corporate clients, and family trips. Vehicles are well-maintained and driven by experienced chauffeurs. It ensures a dependable journey."
  },
  {
    name: "Mumbai Airport to Pune Taxi Fare",
    description: "Mumbai airport to Pune taxi fare is structured to provide transparent and competitive pricing. Fare depends on vehicle type, pickup terminal, and travel time. Customers receive a clear cost breakdown with no hidden charges. Budget and premium options are available. It helps travelers plan efficiently."
  },
  {
    name: "Taxi from Mumbai Airport to Pune",
    description: "Taxi from Mumbai airport to Pune offers convenient door-to-door service with direct pickup from arrival terminals. This service is perfect for travelers looking for a comfortable and quick transfer. Vehicles are clean and driven by professional drivers. It ensures a smooth and stress-free journey."
  },
  {
    name: "Mumbai Pune Cab One Way",
    description: "Mumbai Pune cab one way is a cost-effective option for travelers needing a single-side drop. This service eliminates return fare charges and offers flexible pickup timings. Ideal for airport transfers and business travel. Comfortable vehicles ensure a smooth ride. It is perfect for budget travel."
  },
  {
    name: "Mumbai to Pune Cab from Airport",
    description: "Mumbai to Pune cab from airport provides direct travel from airport terminals to Pune with ease and convenience. This service is ideal for passengers arriving at Mumbai airport. Professional drivers ensure timely pickups and safe travel. It ensures a reliable transfer experience."
  },
  {
    name: "Mumbai Airport Terminal 2 to Pune Cab",
    description: "Mumbai airport Terminal 2 to Pune cab service offers dedicated pickup from T2 for domestic and international passengers. This service ensures quick exit from the airport and smooth highway travel. Comfortable vehicles and experienced drivers enhance the journey. It ensures a hassle-free ride."
  },
  {
    name: "Mumbai Airport to Pune Cab Fare",
    description: "Mumbai airport to Pune cab fare varies depending on vehicle type, timing, and trip type. Transparent pricing ensures no hidden charges. Customers can choose from sedan, SUV, and premium options. It helps travelers select the best option. It ensures value for money."
  },
  {
    name: "Mumbai International Airport to Pune Cab",
    description: "Mumbai international airport to Pune cab service provides seamless transfers for international travelers. This service ensures timely pickup and comfortable travel after long flights. Vehicles are clean and equipped for long-distance journeys. It guarantees a smooth and relaxing ride."
  },
  {
    name: "Mumbai to Pune Taxi from Airport",
    description: "Mumbai to Pune taxi from airport offers a convenient and efficient way to reach Pune directly after arrival. Door-to-door service and flexible pickup timings add convenience. Suitable for business and leisure travel. It ensures a reliable journey."
  },
  {
    name: "Best Cab Service from Mumbai Airport to Pune",
    description: "Best cab service from Mumbai airport to Pune ensures a premium travel experience with top-quality vehicles and professional drivers. This service focuses on punctuality, safety, and customer satisfaction. Multiple vehicle options are available. Transparent pricing builds trust. It guarantees a reliable and comfortable journey."
  },
  {
    name: "Book Taxi from Mumbai Airport to Pune",
    description: "Book taxi from Mumbai airport to Pune for quick and easy reservations with instant confirmation. Customers can choose vehicle type, pickup terminal, and timing as per their preference. Secure booking and transparent pricing enhance convenience. It ensures a hassle-free booking experience."
  },
  {
    name: "Cab Booking from Mumbai Airport to Pune",
    description: "Cab booking from Mumbai airport to Pune allows travelers to reserve their ride easily with flexible travel options. Customers can select from a range of vehicles. Instant confirmation ensures availability at arrival time. It simplifies airport transfer planning."
  },
  {
    name: "Cab Service from Mumbai Airport to Pune",
    description: "Cab service from Mumbai airport to Pune provides reliable and comfortable transportation for long-distance travel. This service is ideal for families, corporate travelers, and tourists. Professional drivers ensure safe journeys. It guarantees a smooth and stress-free experience."
  },
  {
    name: "Mumbai Airport Pickup and Drop to Pune",
    description: "Mumbai airport pickup and drop to Pune service ensures complete transfer solutions including arrival pickup and return drop. This service is ideal for frequent travelers. Comfortable vehicles and flexible schedules add convenience. It ensures a seamless travel experience."
  },
  {
    name: "Mumbai Airport Pune Cab",
    description: "Mumbai airport Pune cab offers direct and comfortable travel between the airport and Pune city. This service is suitable for business and personal travel. Vehicles are clean and driven by experienced drivers. It ensures a reliable journey."
  },
  {
    name: "Mumbai Airport Pune Taxi Service",
    description: "Mumbai airport Pune taxi service offers dependable transportation with a focus on comfort and punctuality. This service is ideal for airport transfers and long-distance travel. Clean vehicles and professional drivers enhance the experience. It guarantees a smooth journey."
  },
  {
    name: "Mumbai Airport to Pune Cab Charges",
    description: "Mumbai airport to Pune cab charges are designed to be affordable and transparent for all travelers. Charges depend on vehicle type and travel plan. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Mumbai Airport to Pune Cab Service",
    description: "Mumbai airport to Pune cab service ensures a premium travel experience with well-maintained vehicles and professional drivers. This service focuses on safety, punctuality, and customer satisfaction. Multiple vehicle options are available. Transparent pricing builds trust. It guarantees a reliable and comfortable journey."
  }
],

tableData: [
  ["Mumbai Airport to Pune Cabs", "Mumbai to Pune Cab Service"],
  ["Mumbai Airport to Pune Taxi Fare", "Taxi from Mumbai Airport to Pune"],
  ["Mumbai Pune Cab One Way", "Mumbai to Pune Cab from Airport"],
  ["Mumbai Airport Terminal 2 to Pune Cab", "Mumbai Airport to Pune Cab Fare"],
  ["Mumbai International Airport to Pune Cab", "Mumbai to Pune Taxi from Airport"],
  ["Best Cab Service from Mumbai Airport to Pune", "Book Taxi from Mumbai Airport to Pune"],
  ["Cab Booking from Mumbai Airport to Pune", "Cab Service from Mumbai Airport to Pune"],
  ["Mumbai Airport Pickup and Drop to Pune", "Mumbai Airport Pune Cab"],
  ["Mumbai Airport Pune Taxi Service", "Mumbai Airport to Pune Cab Charges"]
],


whychoose: [
  {
    WhyChooseheading: "Direct Airport to Pune Pickup Service",
    WhyChoosedescription: "Royal Route Cabs offers seamless Mumbai Airport to Pune cab service with direct pickup from Terminal 1 and Terminal 2 for a hassle-free journey."
  },
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on the Mumbai–Pune Expressway, ensuring safe driving, fast travel, and timely drop in Pune."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Our Mumbai Airport to Pune cab service operates 24/7, ideal for late-night arrivals, early morning flights, and urgent travel."
  },
  {
    WhyChooseheading: "Flight Tracking & On-Time Pickup",
    WhyChoosedescription: "We track your flight timing to ensure on-time pickup even if your flight is delayed, giving you a stress-free airport transfer."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to provide a comfortable travel experience."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way airport drop to Pune or round-trip options based on your travel requirements."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for individuals and group travel."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai Airport to Pune cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai Airport to Pune for one-way and round trips." },
  { question: "Which airport terminals are covered?", answer: "We provide pickup from both Terminal 1 and Terminal 2 of Mumbai Airport." },
  { question: "What is the distance between Mumbai Airport and Pune?", answer: "The distance is approximately 150 to 170 km and takes around 3 to 4 hours via expressway." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our airport cab service operates 24/7." },
  { question: "Do you track flight delays?", answer: "Yes, we monitor flight timings to ensure timely pickup even in case of delays." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide one-way airport transfer services to Pune." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for guaranteed availability." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aditya Joshi",
    feedback: "The Mumbai Airport to Pune cab service with Royal Route Cabs was very smooth and punctual. The driver ensured a comfortable highway journey throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Patil",
    feedback: "Excellent experience traveling from Mumbai Airport to Pune. The cab was clean, the ride was comfortable, and the service felt very reliable.",
    rating: 5
  }
];
















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport to Pune Cabs",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-airport-to-pune-cab.jpg", // replace if needed
  "description": "Book Mumbai Airport to Pune cab with Royal Route Cabs for a safe, comfortable, and reliable transfer. Available from Terminal 1 & Terminal 2 with sedan, SUV, Innova, and luxury cars. 24x7 airport pickup and drop taxi service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-airport-to-pune-cabs"
  }
};




  return (
    <div>

<Helmet>
  <title>Mumbai Airport to Pune Cabs | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai Airport to Pune cab at best price with Royal Route Cabs. Airport pickup & drop from Terminal 1 & 2 with sedan, SUV, Innova & luxury cars. Safe & 24x7 taxi service available."
  />

  <meta
    name="keywords"
    content="Mumbai Airport to Pune Cabs, Mumbai to pune cab service, Mumbai airport to pune taxi fare, taxi from mumbai airport to pune, Mumbai pune cab one way, Mumbai to pune cab from airport, Mumbai airport terminal 2 to pune cab, Mumbai airport to pune cab fare, Mumbai international airport to pune cab, Mumbai to pune taxi from airport, best cab service from mumbai airport to pune, book taxi from mumbai airport to pune, cab booking from mumbai airport to pune, Mumbai airport to pune cab, Mumbai airport pune taxi service, Mumbai airport to pune cab charges, Mumbai airport to pune car hire, Mumbai airport to pune car rental, Mumbai airport to pune drop, Mumbai airport to pune innova, Mumbai airport to pune prepaid taxi fare, Mumbai airport to pune taxi online booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/25.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairporttopunecab;